import { trackR2BReferralsClickOnPromoBannerClick } from "@faire/web-api--source/events/r2BReferrals/click/clickOnPromoBanner";
import userBrandReferrals from "@faire/web-api--source/routes/www/user/brand-referrals";
import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";
import { Typography } from "@faire/web/slate/Typography";
import { EmbeddedLink } from "@faire/web/ui/EmbeddedLink";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { type JSX } from "react";

export const ReferralFollowupBanner: React.FC = () => {
  const bonusOffersReferralNamesList = getGlobalProperty<Array<string>>(
    "referralBonusOfferReferralNames"
  );

  return (
    <Typography align="center">
      <StrictLocalMsg
        id="f1fN02"
        defaultMessage="Limited-time offer: give {brandsWithBonusNumber} brands you invited one-on-one assistance from Faire. <LinkFormatting>Go to Referrals</LinkFormatting>"
        values={{
          brandsWithBonusNumber: bonusOffersReferralNamesList?.length ?? 0,
          LinkFormatting: (chunks) => LinkFormatting(chunks),
        }}
      />
    </Typography>
  );
};

const LinkFormatting = (chunks: JSX.Element) => (
  <EmbeddedLink
    linkTo={userBrandReferrals()}
    onClick={trackR2BReferralsClickOnPromoBannerClick}
    color="inherit"
  >
    {chunks}
  </EmbeddedLink>
);
